import io from 'socket.io-client';
import config from '../constants/config';
import { getGUID } from './session';

class MqttSocketClient {
    constructor() {
        this.socket = null;
        this.isConnected = false;
        this.subscribeTopicList = {};
        this.clientInfo = null;
        this.onMessageCb = null;
        this.socketConnectAttempt = 0;

        this.connect = this.connect.bind(this);
        this.mqttConnect = this.mqttConnect.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.subscribeAll = this.subscribeAll.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.onMessageReceive = this.onMessageReceive.bind(this);
        this.addMessageReceiver = this.addMessageReceiver.bind(this);
        this.removeMessageReceiver = this.removeMessageReceiver.bind(this);
        this.destroy = this.destroy.bind(this);
        this.parseJSON = this.parseJSON.bind(this);
    }

    connect(cb) {
        if (!config.mqtt.IS_ENABLE) return cb('Websocket connectivity is disabled!');

        const $this = this;
        if (this.socket) {
            this.socket.destroy();
            delete this.socket;
            this.socket = null;
        }

        this.socket = io.connect(config.mqtt.BROKER_SOCKET_IP, { reconnection: true });
        this.socket.on('connect', () => {
            $this.isConnected = true;
            $this.mqttConnect(cb);

            $this.socket.on('mqtt-connected', () => {
                $this.subscribeAll();

                $this.socket.on('mqtt-message', (data) => {
                    if (!$this.onMessageCb) return;

                    const arrTopic = data.topic.split("/");
                    if (arrTopic.length > 0) {
                        const rTopicName = arrTopic[arrTopic.length - 1];
                        const rExternalId = arrTopic[6];
                        data['message'] = String(data.message).length > 0 ? $this.parseJSON(data.message) : null;
                        data['name'] = rTopicName.toLowerCase();
                        data['deviceId'] = rExternalId;
                        Object.keys($this.onMessageCb).forEach(key => {
                            if ($this.onMessageCb[key].topics === null) $this.onMessageCb[key].cb(data);
                            else if ($this.onMessageCb[key].topics.indexOf(rTopicName) >= 0) $this.onMessageCb[key].cb(data);
                        });
                    }
                });
            });
        });

        this.socket.on('disconnect', () => {
            $this.isConnected = false;
            $this.interval = window.setInterval(() => {
                $this.socketConnectAttempt++;
                if ($this.isConnected) {
                    clearInterval($this.interval);
                    $this.interval = null;
                    return;
                }
                $this.connect(cb);
            }, 5000);
        });

        return this.socket;
    }

    mqttConnect(cb) {
        if (this.clientInfo == null) {
            this.clientInfo = { clientId: getGUID(), username: null, password: null }
            if (this.clientInfo) {
                this.socket.emit('mqtt-connect', this.clientInfo);
                return cb(null);
            } else return cb('Device id not found for live data display');
        } else {
            this.socket.emit('mqtt-connect', this.clientInfo);
            return cb(null);
        }
    }

    subscribe(topics, group = false) {
        const getQos = (qos) => { return (qos ? qos : 0) };
        let topicList = {};

        if (Array.isArray(topics)) {
            topics.forEach(element => {
                (element.hasOwnProperty('deviceId') && element.hasOwnProperty('name')) ?
                    topicList[this.getTopic(element.deviceId, element.name)] = getQos(element.qos) :
                    topicList[element] = getQos(element.qos);
            });
        } else if (typeof topics === 'object') {
            if (topics.hasOwnProperty('deviceId') && topics.hasOwnProperty('name'))
                topicList[this.getTopic(topics.deviceId, topics.name)] = getQos(topics.qos);
        }
        else topicList[topics] = getQos(topics.qos);

        if (group && this.isConnected && this.subscribeTopicList.hasOwnProperty(group)) {
            let topicArr = [];
            Object.keys(this.subscribeTopicList[group]).forEach(topic => {
                if (!topicList.hasOwnProperty(topic)) topicArr.push(topic);
            });
            if (topicArr.length > 0) this.socket.emit('mqtt-unsubscribe', { topic: topicArr });
        }

        if (group) this.subscribeTopicList[group] = topicList;
        if (this.isConnected) this.socket.emit('mqtt-subscribe', { topic: topicList, qos: getQos(topics.qos) });
    }

    subscribeAll() {
        const $this = this;
        Object.keys(this.subscribeTopicList).forEach(group => {
            $this.socket.emit('mqtt-subscribe', { topic: $this.subscribeTopicList[group] });
        });
    }

    unsubscribe(param) {
        if (typeof param === 'string') {
            const group = param;
            if (this.subscribeTopicList.hasOwnProperty(group)) {
                let topicArr = [];
                Object.keys(this.subscribeTopicList[group]).forEach(topic => {
                    topicArr.push(topic);
                });
                if (topicArr.length > 0) this.socket.emit('mqtt-unsubscribe', { topic: topicArr });
            }
        } else if (param.hasOwnProperty('deviceId') && param.hasOwnProperty('name')) {
            this.socket.emit('mqtt-unsubscribe', { topic: this.getTopic(param.deviceId, param.name) });
        }
    }

    getTopic(deviceId, name) {
        return config.mqtt.TOPIC_FORMAT.replace('#external_id#', deviceId).replace('#name#', name);
    }

    onMessageReceive(cb) {
        this.addMessageReceiver('default_message', null, cb);
    }

    addMessageReceiver(name, topics, cb) {
        if (!this.onMessageCb) this.onMessageCb = {};
        this.onMessageCb[name] = { topics: topics, cb: cb };
    }

    removeMessageReceiver(name) {
        if (this.onMessageCb.hasOwnProperty(name)) delete this.onMessageCb[name];
    }

    destroy() {
        if (this.socket) {
            this.socket.destroy();
            delete this.socket;
            this.socket = null;
        }
    }

    parseJSON(message) {
        try {
            return JSON.parse(message);
        } catch (error) {
            return null;
        }
    }

    getSocket() {
        return this.socket;
    }
}
export default MqttSocketClient;